<template>
  <v-menu
    bottom left
    offset-y
    :close-on-content-click="false"
    open-on-hover
    max-width="350"
    content-class="post-share"
  >
    <v-btn icon flat slot="activator" @mouseenter.native="hover">
      <!-- <v-icon v-if="post.publicKey">lock_open</v-icon> -->
      <!-- <v-icon v-if="post.publicKey">public</v-icon> -->
      <v-icon v-if="post.publicKey">share</v-icon>
      <v-icon v-else>lock_outline</v-icon>
    </v-btn>
    <v-card v-if="post.publicKey">
      <v-card-title primary-title>
        <div class="public-url">{{ publicUrl }}</div>
        Це публічний пост. Він доступний будь-кому за посиланням, наведеним вище.
      </v-card-title>
    </v-card>
    <v-card v-else>
      <v-card-title primary-title>
        Це приватний пост. Його можуть бачити лише Наші.
      </v-card-title>
    </v-card>
  </v-menu>
</template>

<script>

export default {
  name: 'PostShare',
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    publicUrl() {
      return location.href;
    },
  },
  methods: {
    hover() {
      this.$ga.event('post-share-info', 'opened', location.pathname);
    },
  },
};

</script>

<style scoped>

.public-url {
  border: dashed 1px #ddd;
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  background: #f9f9f9;
  font-size: 14px;
  word-break: break-all;
}

</style>



// WEBPACK FOOTER //
// src/components/PostShare.vue